import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Home, ArrowLeft, Sparkles } from 'lucide-react';

function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="relative min-h-screen overflow-hidden bg-[#0f0f0f] flex items-center justify-center px-4">
      
      {/* Background Glow */}
      <div className="absolute inset-0">
        <div className="absolute top-[-120px] left-[-120px] w-[320px] h-[320px] bg-QWA2_TALENT_SHOW-red/20 blur-3xl rounded-full" />
        <div className="absolute bottom-[-120px] right-[-120px] w-[320px] h-[320px] bg-QWA2_TALENT_SHOW-gold/20 blur-3xl rounded-full" />
      </div>

      {/* Floating Circles */}
      <div className="absolute top-20 left-10 w-20 h-20 border border-white/10 rounded-full animate-pulse" />
      <div className="absolute bottom-24 right-16 w-12 h-12 border border-white/10 rounded-full animate-bounce" />

      {/* Main Card */}
      <div className="relative z-10 max-w-xl w-full backdrop-blur-xl bg-white/5 border border-white/10 rounded-[32px] p-8 md:p-12 shadow-[0_0_60px_rgba(0,0,0,0.4)] text-center">
        
        {/* Icon */}
        <div className="mx-auto mb-6 flex items-center justify-center w-20 h-20 rounded-full bg-gradient-to-r from-QWA2_TALENT_SHOW-red to-QWA2_TALENT_SHOW-gold shadow-lg">
          <Sparkles className="w-10 h-10 text-white" />
        </div>

        {/* 404 */}
        <h1 className="text-7xl md:text-9xl font-black bg-gradient-to-r from-QWA2_TALENT_SHOW-red to-QWA2_TALENT_SHOW-gold bg-clip-text text-transparent leading-none">
          404
        </h1>

        {/* Text */}
        <h2 className="mt-6 text-3xl md:text-4xl font-bold text-white">
          Lost in Space?
        </h2>

        <p className="mt-4 text-gray-300 text-base md:text-lg leading-relaxed max-w-md mx-auto">
          The page you're looking for doesn’t exist, was moved, or never existed at all.
        </p>

        {/* Buttons */}
        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
          
          <Button
            onClick={() => navigate(-1)}
            variant="outline"
            className="h-14 px-6 rounded-2xl border-white/20 bg-white/5 text-white hover:bg-white/10 transition-all duration-300 flex items-center gap-2"
          >
            <ArrowLeft className="w-5 h-5" />
            Go Back
          </Button>

          <Button
            onClick={() => navigate('/')}
            className="h-14 px-8 rounded-2xl bg-gradient-to-r from-QWA2_TALENT_SHOW-red to-QWA2_TALENT_SHOW-gold text-white font-bold uppercase tracking-wider shadow-lg hover:scale-105 transition-all duration-300 flex items-center gap-2"
          >
            <Home className="w-5 h-5" />
            Back Home
          </Button>
        </div>
      </div>
    </div>
  );
}

export default NotFound;